module.exports = __webpack_public_path__ + "static/img/informationNew.bfdd868.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/informationNew.png
// module id = /hwG
// module chunks = 0